"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPodcastEpisodeStencil = exports.podcastEpisodeStencilDefinition = void 0;
const properties_1 = require("../properties");
const no_monetization_property_1 = require("../properties/no-monetization.property");
const wrcErcContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'subheading',
            'teaser',
            'podcast-essence',
            'story-content',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'featured-media',
                    'uri-title',
                    'url',
                    'hosts',
                    'podcast-season',
                    'transcript',
                    'episode-number',
                    'logos',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'standalone',
                    'no-monetization',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'content-categories',
            'disciplines',
            'tag-events',
            'tag-event-series',
            'tag-rally-drivers',
            'tag-rally-teams',
            'related-content',
        ],
    },
];
exports.podcastEpisodeStencilDefinition = {
    view: {
        label: 'Podcast episode',
        group: 'Audio',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'podcast-essence',
                    'story-content',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'featured-media',
                            'uri-title',
                            'url',
                            'hosts',
                            'podcast-season',
                            'transcript',
                            'episode-number',
                            'logos',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'standalone',
                            'no-monetization',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'content-categories',
                    'disciplines',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        [properties_1.contentCategoriesPropertyDefinition.name]: properties_1.contentCategoriesPropertyDefinition,
        [properties_1.ctaContainerPropertyDefinition.name]: properties_1.ctaContainerPropertyDefinition,
        [properties_1.disciplinesPropertyDefinition.name]: properties_1.disciplinesPropertyDefinition,
        [properties_1.episodeNumberPropertyDefinition.name]: properties_1.episodeNumberPropertyDefinition,
        [properties_1.featuredMediaPropertyDefinition.name]: properties_1.featuredMediaPropertyDefinition,
        [properties_1.featuredTitlePropertyDefinition.name]: properties_1.featuredTitlePropertyDefinition,
        [properties_1.headerMediaPropertyDefinition.name]: properties_1.headerMediaPropertyDefinition,
        [properties_1.hostsPropertyDefinition.name]: properties_1.hostsPropertyDefinition,
        [properties_1.logosPropertyDefinition.name]: properties_1.logosPropertyDefinition,
        [no_monetization_property_1.noMonetizationPropertyDefinition.name]: no_monetization_property_1.noMonetizationPropertyDefinition,
        [properties_1.podcastEssencePropertyDefinition.name]: properties_1.podcastEssencePropertyDefinition,
        [properties_1.podcastSeasonPropertyDefinition.name]: properties_1.podcastSeasonPropertyDefinition,
        [properties_1.propertiesContainerPropertyDefinition.name]: properties_1.propertiesContainerPropertyDefinition,
        [properties_1.relatedContentPropertyDefinition.name]: properties_1.relatedContentPropertyDefinition,
        [properties_1.searchTermsPropertyDefinition.name]: properties_1.searchTermsPropertyDefinition,
        [properties_1.seoTitlePropertyDefinition.name]: properties_1.seoTitlePropertyDefinition,
        [properties_1.socialTitlePropertyDefinition.name]: properties_1.socialTitlePropertyDefinition,
        [properties_1.standalonePropertyDefinition.name]: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        [properties_1.storyContentPropertyDefinition.name]: properties_1.storyContentPropertyDefinition,
        [properties_1.subheadingPropertyDefinition.name]: {
            ...properties_1.subheadingPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 45,
                },
            ],
        },
        [properties_1.tagEventSeriesPropertyDefinition.name]: properties_1.tagEventSeriesPropertyDefinition,
        [properties_1.tagEventsPropertyDefinition.name]: properties_1.tagEventsPropertyDefinition,
        [properties_1.tagPersonsPropertyDefinition.name]: properties_1.tagPersonsPropertyDefinition,
        [properties_1.tagRallyDriversPropertyDefinition.name]: properties_1.tagRallyDriversPropertyDefinition,
        [properties_1.tagRallyTeamsPropertyDefinition.name]: properties_1.tagRallyTeamsPropertyDefinition,
        [properties_1.tagTeamsPropertyDefinition.name]: properties_1.tagTeamsPropertyDefinition,
        [properties_1.teaserPropertyDefinition.name]: {
            ...properties_1.teaserPropertyDefinition,
            constraints: [
                {
                    name: 'maxLength',
                    argument: 250,
                },
                {
                    name: 'required',
                    argument: true,
                },
            ],
        },
        [properties_1.titlePropertyDefinition.name]: properties_1.titlePropertyDefinition,
        [properties_1.transcriptPropertyDefinition.name]: properties_1.transcriptPropertyDefinition,
        [properties_1.uriTitlePropertyDefinition.name]: properties_1.uriTitlePropertyDefinition,
        [properties_1.urlPropertyDefinition.name]: properties_1.urlPropertyDefinition,
    },
    roles: [],
    localizations: [],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'redbull-racing',
        'redbull-powertrains',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
    ],
    name: 'podcast-episode',
    overwrites: [
        {
            condition: 'space',
            argument: 'erc',
            contentAreas: wrcErcContentAreas,
        },
        {
            condition: 'space',
            argument: 'wrc',
            contentAreas: wrcErcContentAreas,
        },
    ],
};
const isPodcastEpisodeStencil = (stencil) => {
    return stencil.name === exports.podcastEpisodeStencilDefinition.name;
};
exports.isPodcastEpisodeStencil = isPodcastEpisodeStencil;
//# sourceMappingURL=data:application/json;base64,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